<template>
  <div class="page">
    <!-- 导航条 -->
    <navigation type="second-level" :sticky="true">小美VIP优惠</navigation>
    <div class="quan-item">
      <template v-if="xiaomeiVIPArray.length>0">
        <nd-item  v-for="(item,index) in xiaomeiVIPArray"
                  :key="index"
                  :index="index"
                  :activeType="getPacketDescription(item.activeType)"
                  :couponType="getPacketType(item.memberCouponType)"
                  :endTime="getValidTimeDesc(item.endTime)"
                  :money="getMoney(item.discountAmt)"
                  :detail="item.useDesc"
                  :unit="getUnit(item)"
                  :isSelected="item.isSelected"
                  @changeSelected="changeSelected"
                  :showSelect="true"
                  :showInfoBool="true"
                  useTitle="VIP会员免息红包"
        >
        </nd-item>
      </template>
      <template v-else>
        <div class="none">
          <img src="./image/img_quanbao@2x.png" class="none-img"/>
          <p class="none-content">这里空空如也...</p>
        </div>
      </template>
    </div>
    <footer>
      <span @click="jumpHistory" class="history">查看历史优惠</span>
      <section>
        <div class="button-list">
          <div class="left-button"><span>已优惠 ¥ {{Number(discountAmt)|currency}}</span></div>
          <div class="right-button" @click="confirm" data-sensors-click><span>确认</span></div>
        </div>
      </section>
    </footer>
  </div>
</template>
<script>
export default {
  name: 'xiaoMeiVIP',
  data () {
    return {
      xiaomeiVIPArray: JSON.parse(sessionStorage.getItem('xiaomeiVIPArray')) || [],
      fundCode: this.$route.query.fundCode
    }
  },
  computed: {
    discountAmt () {
      let number = 0
      this.xiaomeiVIPArray.map(item => {
        if (item.isSelected) {
          number = number + item.discountAmt
        }
      })
      return number
    }
  },
  methods: {
    getPacketDescription (activeType) {
      if (activeType === 'XIAOMEI_VIP') {
        return '小美VIP会员'
      }
    },
    // 选择数据变化
    changeSelected (index) {
      let type = '' // 是否已选择同种类型的红包
      this.xiaomeiVIPArray.map((item) => {
        if (item.memberCouponType === 'CASH' && this.xiaomeiVIPArray.filter((i, number) => i.memberCouponType === 'CASH' && i.isSelected && number !== index).length > 0) {
          type = 'CASH'
        } else if (item.memberCouponType === 'COUPON' && this.xiaomeiVIPArray.filter((i, number) => i.memberCouponType === 'COUPON' && i.isSelected && number !== index).length > 0) {
          type = 'COUPON'
        }
      })
      if (type === 'CASH') {
        this.$message('该订单现金红包不可叠加使用')
      } else if (type === 'COUPON') {
        this.$message('该订单免息红包不可叠加使用')
      } else {
        this.xiaomeiVIPArray = this.xiaomeiVIPArray.map((item, inx) => {
          if (index === inx) {
            item.isSelected = !item.isSelected
          }
          return item
        })
      }
    },
    // 红包类型
    getPacketType (memberCouponType) {
      // REDUCTION_INTEREST 实际现金红包 但是 要显示为免息红包
      if (memberCouponType === 'COUPON') {
        return '免息红包'
      } else if (memberCouponType === 'CASH') {
        return '现金红包'
      }
    },
    // 时间
    getValidTimeDesc (endTime) {
      return `红包激活有效期至：${this.formatDate(endTime, 'YYYY/MM/DD')}`
    },
    // 跳转历史优惠界面
    jumpHistory () {
      sessionStorage.setItem('xiaomeiVIPArray', JSON.stringify(this.xiaomeiVIPArray))
      this.$router.push('/quan/history')
    },
    // 金额
    getMoney (value) {
      if (value) {
        return Number(value).toFixed(2)
      } else {
        return '--'
      }
    },
    getUnit () {
      return '元'
    },
    // 确认界面
    confirm () {
      sessionStorage.setItem('xiaomeiVIPArray', JSON.stringify(this.xiaomeiVIPArray))
      this.$router.replace({ path: '/withdraw/preview', query: { fundCode: this.fundCode } })
    }
  }
}
</script>
<style scoped lang="less">
@import "../../assets/less/mixin.less";

.page{
  width: 750px;
  height:100%;
  background: #FAFAFA;
  .quan-item{
    overflow: scroll;
    margin-top:18px;
    padding-bottom:350px;
  }
  .none{
    margin-top:263px;
    text-align:center;
    &-img{
      width:204px;
      height:173px;
    }
    &-content{
      margin-top:37px;
      height: 36px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 36px;
    }
  }
  footer{
    position: fixed;
    bottom:0;
    height:320px;
    width:100%;
    text-align: center;
    background:white;
    padding-top:20px;
    .history{
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 40px;
      text-align: center;
    }
    section{
      width: 750px;
      height: 230px;
      background: #FFFFFF;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.04);
      margin-top:38px;
      padding-top:38px;
      .button-list{
        height:94px;
        padding:0 50px;
        display:flex;
        .left-button{
          width: 325px;
          height: 94px;
          line-height: 94px;
          background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%);
          border-radius: 47px 0px 0px 47px;
          >span{
            height: 45px;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #763E12;
            line-height: 45px;
          }
        }
        .right-button{
          width: 325px;
          height: 94px;
          line-height: 94px;
          background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
          border-radius: 0px 47px 47px 0px;
          >span{
            height: 45px;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 45px;
          }
        }
      }
    }
  }
}
</style>